import { ReportType } from 'shared/domain/report/types/model/common';
import { isInspectionReportType } from 'shared/domain/report/types/model/reportTypeGuards';
import { ReactElement } from 'react';
import { InspectionContentSelection } from './inspection';
import { IssueContentSelection } from './issue';

export function ContentSelection({
  reportType,
}: {
  reportType: ReportType;
}): ReactElement {
  if (isInspectionReportType(reportType)) {
    return <InspectionContentSelection />;
  }

  return <IssueContentSelection reportType={reportType} />;
}
